<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u9BQ8G/images/e9781439617311_cover.jpg?1684514754442" alt="This image is the cover for the book Garrett County, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Garrett County, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>Established in 1872, Garrett, Maryland�s westernmost county, was the last county created in the state and is named for John Work Garrett, then president of the Baltimore &amp; Ohio Railroad. The images presented here were selected with care from the author�s collection of several thousand postcards. Featured are Garrett�s numerous towns and communities; downtown business scenes; residential views; historic buildings, churches, railroad stations; and the great resort hotels. Also included are the county�s many historic and natural landmarks, rustic scenes, the Deep Creek Lake area, and varied sites along the historic National Road. A special element is the inclusion of many of the personal messages sent on the back of the postcards.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Albert L. Feldstein
      </h2>
      
      <p class="authorDescription body article">This is Albert L. Feldstein�s sixth publication chronicling the history of Garrett County. As always, Feldstein provides a comprehensive, informative, and visually entertaining portrayal of the county�s history and heritage. An award-winning amateur historian, Feldstein has, since 1980, published 27 books and videotapes and spoken to hundreds of groups on the history of all three western Maryland counties as well as nearby West Virginia. Along with historic photographs and postcards, Feldstein is an avid collector of political campaign and �protest� buttons.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbdb84e8